import { render, staticRenderFns } from "./Reply.vue?vue&type=template&id=f2c4fde2&scoped=true"
import script from "./Reply.vue?vue&type=script&lang=js"
export * from "./Reply.vue?vue&type=script&lang=js"
import style0 from "./Reply.vue?vue&type=style&index=0&id=f2c4fde2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c4fde2",
  null
  
)

export default component.exports